import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

const getPermissions = async () => {
  const data = await getDataWithDotNet(`${ajaxEndpoints.PERMISSIONS}`);

  return data;
};

export default function useAllPermissions() {
  return useQuery("getPermissions", getPermissions, {
    refetchOnWindowFocus: false,
  });
}
